import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

/**
 * Fetch paginated user requests (admin).
 * config.params supports: type, status, category, page, limit
 */
function useGetAdminRequests(data = {}) {
  const { enabled = false, config = {}, queryKey } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const key = queryKey ?? ['admin-user-requests', params];

  return useQuery(
    key,
    () => privateFetch.get('/v1/admin/podcast/user-requests', { params }).then((r) => r.data),
    { enabled, keepPreviousData: true }
  );
}

export default useGetAdminRequests;
